/** 各APPID */
export enum AppInfo {
  "新重庆" = 1,
  "巫山" = 2,
  "五彩石柱" = 3,
  "掌新南岸" = 4,
  "巫溪" = 5,
  "人人长寿" = 6,
  "武隆印象" = 7,
  "今日合川" = 8,
  "永川头条" = 9,
  "铜梁" = 10,
  "和美璧山" = 11,
  "渝北掌媒" = 12,
  "秀山e家" = 13,
  "品位忠州" = 14,
  "缙享北碚" = 15,
  "爱涪陵" = 16,
  "大美綦江" = 17,
  "花漾垫江" = 18,
  "在渝中" = 19,
  "家在奉节" = 20,
  "苗乡彭水" = 21,
  "帅开州" = 22,
  "家在梁平" = 23,
  "酉州城事" = 24,
  "最江津" = 25,
  "家在黔江" = 26,
  "重庆江北" = 27,
  "看万州" = 28,
  "幸福万盛" = 29,
  "重庆荣昌" = 30,
  "看丰都" = 31,
  "今日南川" = 32,
  "美好九龙坡" = 33,
  "看巴南" = 34,
  "掌上城口" = 35,
  "沙坪坝微政务" = 36,
  "新潼南" = 37,
  "掌上大足" = 38,
  "义渡热爱" = 39,
  "智慧云阳" = 40,
  "无线铜梁" = 41,
  "全球渝商" = 50,
  "重庆市政府" = 53
}

export enum ColumnInfo {
  "滚动新闻" = 27001,
  "精彩图集" = 27002,
  "视频新闻" = 27003,
  "融媒策划" = 27004,
  "外媒聚焦" = 27005
}

export enum ColumnInfo2023 {
  // 2023
  "滚动新闻" = 27051,
  "精彩图集" = 27052,
  "视频新闻" = 27053,
  "融媒策划" = 27054,
  "外媒聚焦" = 27055
}

export enum ColumnInfo2024 {
  // 2024
  "滚动新闻" = 27065,
  "精彩图集" = 27066,
  "视频新闻" = 27067,
  "融媒策划" = 27068,
  "外媒聚焦" = 27069
}
